import chunk from 'lodash/chunk';
import flatten from 'lodash/flatten';

let autocompleteService;
const countriesToQuery = ['dk', 'de', 'no', 'se', 'gb', 'fi', 'fr', 'be', 'gg', 'gl', 'is', 'fo', 'lv', 'es', 'ch'];
const maxCountriesToQuery = 5;

function init() {
	if (!autocompleteService) {
		autocompleteService = new google.maps.places.AutocompleteService(null, { types: ['geocode'] });
	}
}

/**
 * @param {string} query
 */
export function autocomplete(query) {
	return makeBatchQuery(query, countriesToQuery);
}

/**
 * Query a into batches
 *
 * @param {string} query
 * @param {string[]} [countries=[]]
 * @returns {Promise<any[]>}
 */
function makeBatchQuery(query, countries) {
	const batches = chunk(countries, maxCountriesToQuery);

	return Promise.all(batches.map( countriesBatch => queryCountryBatch(query, countriesBatch) ))
		.then(flatten);
}

/**
 * Query a batch of 5 countries
 *
 * @param {string} query
 * @param {string[]} [countries=[]]
 * @returns {Promise<any[]>}
 */
function queryCountryBatch(query, countries = []) {
	console.log(`Querying '${query}' with batch ${countries.join()}`)
	return new Promise( (resolve, reject) => {
		init();

		const request = {
			input: query,
			componentRestrictions: { country: countries },
			// types: ['(regions)'],
		}
		autocompleteService.getPlacePredictions(
			request,
			(predictions, status) => {
				if (status === 'OK') {
					return resolve(formatPredictions( predictions ));
				} else if (status === 'ZERO_RESULTS') {
					return resolve([]);
				}

				console.error('rejected with', status);
				return reject(status);
			});

	});
}

function formatPredictions( predictions ) {
	const response = [];

	for ( let i = 0; i < 5; ++i ) {
		if ( predictions[ i ] ) {
			( function ( i ) {
				const place = {
					label: predictions[ i ].description,
					place_id: predictions[ i ].place_id,
				};
				response.push( place );
			} )( i );
		}
	}

	return response;
}



// WEBPACK FOOTER //
// ./assets/_js/components/google-autocomplete/autocomplete.js